import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/settings.css';

import {ASSETS_URL} from '../../../../constants/endpoints';

import {getText} from '../../../../helpers/localization';
// actions
import {openCloseSettings} from '../../../../actions/settingsActions';
import {setVideoVisibility} from '../../../../actions/systemActions';
import CheckCircle from '../../sharedComponents/components/checkCircle';

const mapStateToProps = (state, ownProps) => {
    return {
        isSettingsOpen: state.vpp.isSettingsOpen,
        isDesktopMode: state.vpp.isDesktopMode,
        isVideoVisible: state.vpp.isVideoVisible
    };
};

class Settings extends Component {
    constructor(props) {
        super(props);
        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            isSettingsOpen: storeData.vpp.isSettingsOpen,
            isDesktopMode: storeData.vpp.isDesktopMode,
            isVideoVisible: storeData.vpp.isVideoVisible
        };
    }

    componentDidMount() {
        document.body.style.overflow = 'hidden';
    }

    componentWillUnmount() {
        document.body.style.overflow = 'auto';
    }

    componentWillReceiveProps(nextProps) {
        let store = this.props.store;
        let storeData = store.getState();
        this.setState(
            {
                isSettingsOpen: storeData.vpp.isSettingsOpen,
                isDesktopMode: storeData.vpp.isDesktopMode,
                isVideoVisible: storeData.vpp.isVideoVisible
            }
        );
    }

    _closeSettings(event) {
        event.stopPropagation();
        this.props.store.dispatch(openCloseSettings());
    }

    render() {

        let settingsContainerStyle;
        if (this.state.isDesktopMode) {
            if (this.state.isVideoVisible) {
                settingsContainerStyle = style.settingsContainer;
            } else {
                settingsContainerStyle = style.settingsContainerCenter;
            }
        } else {
            settingsContainerStyle = style.settingsContainerMobile;
        }

        let setVideoVisibilityButton;
        if (this.state.isVideoVisible) {
            setVideoVisibilityButton = (
                <div className={style.setVideoVisibilityButtonContainer}>
                    <div className={style.setVideoVisibilityButtonText}>{getText('SHOW_VIDEO', this.props.store)}</div>
                    <div className={style.setVideoVisibilityButtonCheckbox}>
                        <CheckCircle
                            htmlId={'setVideoVisibilityButton'}
                            style={style.checkContainer}
                            isChecked={this.state.isVideoVisible}
                            isEnabled={true}
                            callback={() => this.props.store.dispatch(setVideoVisibility(!this.state.isVideoVisible))}/>
                    </div>
                </div>
            );
        }

        return (
            <div className={style.settingsBackground} onClick={(event) => this._closeSettings(event)}>
                <div className={settingsContainerStyle} onClick={(event) => event.stopPropagation()}>
                    <div className={style.topContainer}>
                        <div className={style.titleContainer}>
                            <div className={style.title}>
                                {getText('SETTINGS', this.props.store)}
                            </div>
                        </div>
                        <div id='settingsCloseBtn' onClick={(event) => this._closeSettings(event)}>
                            <img src={`${ASSETS_URL}close.svg`} className={style.closeButton} alt={'close'}/>
                        </div>
                    </div>
                    <div id={'settings_container'} className={style.content}
                         onClick={(event) => event.stopPropagation()}>
                        <div className={style.buttonsContainer}>
                            {setVideoVisibilityButton}
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(Settings);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/sharedComponents/containers/settings.js